/* eslint-disable n/no-exports-assign */

'use strict';

var utils = {
  stripNumber: function stripNumber(field, value, raw) {
    var val = value;
    if (!val || val === 0) {
      return val;
    } // return zeros and blanks

    if (field && field.type && field.type === 'timer' && raw) {
      return raw; // timer could have a formatted value like 0.5 hours
    }
    val = String(val);
    var format = field && field.format ? field.format : {};
    var markDecimal = '.';
    if (format.mark_decimal && format.mark_decimal === 'comma' && format.precision) {
      markDecimal = ',';
    }
    var markThousands = ',';
    if (format.mark_thousands && format.mark_thousands !== 'none' && format.mark_thousands !== 'comma') {
      markThousands = format.mark_thousands === 'space' ? ' ' : '\\.';
    }
    if (markThousands !== ',') {
      val = val.replace(new RegExp(markThousands, 'g'), '');
    }
    if (markDecimal !== '.') {
      val = val.replace(new RegExp(markDecimal, 'g'), '.');
    }
    val = Number(val.replace(/[^0-9\.\-]+/g, "")); // eslint-disable-line

    return val;
  }
};
module.exports = utils;